import Styled from "styled-components"
import { Link } from "gatsby"
import { keyframes } from "styled-components"
const fadeAnimation = keyframes`
 0% { opacity: 0 ; margin:100px; }
 100% { opacity: 1; margin: 1px}
`
const FadeFromRight = keyframes`
0% { opacity: 0  ;left:100% }
100% { opacity: 1; left: 0%}
`
const Fill = keyframes`
0%,10%,100%{width: 0;}
70%,90%{width: 40% 
}
`
const ProjectAnimation = keyframes`
0%{width:250px; }
100%{width: 450px;
}
`
const StyledTaps = Styled.div`

width: 100%;
display: flex;
justify-content: flex-end;
font-size: 20px;
margin: 5px;
color:white;
animation-name: ${FadeFromRight};
animation-duration: 5s;
animation-iteration-count:1;
`
const FadeText = Styled.div`
font-size: 2vmax;
animation-name: ${fadeAnimation};
 animation-duration: 5s;
 animation-iteration-count: 1;

`
const FadeText2 = Styled.h2`
color: #b94646;
-webkit-text-stroke: 0.3vw #b94646;
text-transform: uppercase;
position: relative;
&::before{
  content: attr(data-text);
  position: absolute;
  top: 10;
  left:10;
  width: 0;
  height: 100%;
  color: white;
  -webkit-text-stroke: 0px #b94646;
  border-right: 2px solid white;
  overflow: hidden;
  animation: ${Fill} 6s linear infinite;
}
`
const StyledFooter = Styled.div`
    position:absolute;
    top: 110em;
    margin: 0;
    padding: 0;
    height: 150px;
    width: 100%;
    background-color: #060c21;
    color: white;
     border-top: 5px solid black;
    `

const StyledLayout = Styled.div`
font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  background-color: white;
  color: white;
  text-align: center;
  width: auto;

  //   min-height: 100vh;
  #main-content {
    color: black;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    // padding: 0 2.5rem;
    text-align: center;
  }
`
const TapTag = Styled(Link)`
font-size:1.8em;
color: white;
font-weight: bold;
text-decoration: none;
border: 3px solid white;
padding: 2px;
margin: 5px;
:hover{
  opacity: 0.5;
}
`
const StyledButton = Styled(Link)`
margin: 20px !important;
padding: 10px !important;
background: inherit;
color: black;
font-size: 2em;
font-weight: bold;
border: 3px solid black;
text-decoration: none;
:hover{
  cursor: pointer;
  opacity: 0.5;
}
`

const StyledDiv = Styled.div`
border: 1px solid black;
height: 400px;
width: 400px;
margin-bottom: 15px;
box-shadow: 0 4px 8px 0 rgba(0, 0,
0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
text-align: center;
word-wrap: break-word;
white-space: pre-line;
: hover{
  transition: all .2s ease-in-out;
  transform: scale(1.1);
  opacity: 0.5;
}
}
`
const SecretDiv = Styled.div`
:button{
  display:none;
}
:hover{
  :button{
    display: relative;
    text-align: center;

  }
}

`
const Wrapper = Styled.div`
display: flex;
justify-content: center;
align-items: center;
flex-wrap: wrap;
margin-top: 100px;
margin-bottom: 200px
font-family : "Poppins", san-serif;
// background:#060c21;

`
const Container = Styled.div`
position: relative;
padding: 4px;
// width: 90%;
display: grid;
grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
grid-template-rows: auto;
grid-gap: 0 40px;
background: blue;
@media (max-width: 1068px) {
display: flex;
justify-content:center;
margin-left: 100%;
margin-right: 100%;
#box{
  width: 300px;
}
}

:before{
  content: ' ';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: #c43227;
  transform: skew(2deg, 2deg);
  // z-index: -1;

}
 #box{
 position: relative;
 height: 400px;
 background: #060c21;
 display: flex;
 justify-content: center;
 align-items: center;
 border: 1px solid #000;
 &:nth-child(1) {
   
   //  background: linear-gradient(90deg, pink 50%, cyan 50%);
  }
  
  :hover{
  animation-name: ${ProjectAnimation};
  animation-duration: 1s;
  animation-delay: 0.5s;
  animation-timing-function: ease-out;
  animation-fill-mode: forwards;  
  // transform: scaleX(1.5);
  // transition:  .7s;
  // width: 450px;
}
#content{

   color: white;
   position: relative;
   padding: 20px;
   #link{
    position: relative;
    margin: 20px 0 0;
    padding: 10px 20px;
    text-decoration: none;
    border: 1px solid #fff;
    display: inline-block;
    color: #fff;
    transition: 0.5s;
    transform: translateY(-40px);
    opacity: 0;
    visibility: hidden;

    :hover{
      color: #000;
      background: #fff;
    }
  }
   h2{
     position: absolute;
     top: -60px;
     left:20px;
     margin:0;
     padding:0;
     font-size: 4em;
     opacity: 0.5;
     transition: 0.5s;
     margin-bottom: 20px;
   }
   p{
     margin-bottom: 50px;
     padding: 0;
     font-size:24px;
     font-weight: 500;
     color: #fff;
   }

 }

 :hover{

   #content{
     h2{
       top:-130px;
     }
     #link{
      transform: translateY(0);
      opacity: 1;
      visibility: visible;   
     }
   }

 }

 }

`
const StyledForm = Styled.form`
overflow-x: hidden;
display: flex;
flex-wrap: wrap;
flex-direction: column;
justify-content: center;
align-items: center;
font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
border-color: #060c21;
button{
  font-size: 15px;
  display: block;
  width: 20em;
  height: 5em;
  background: #060c21;
  color: white;
  :hover{
    opacity: 0.8;
    cursor: pointer;
  }
}

label {
  display: block;
  text-align: center !important;
}
textarea{
  height: 150px !important;
  width: 300px !important;

}
input[type=text], input[type=email], textarea {
  width: 300px;
  padding: 20px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

`
const FooterLinksDiv = Styled.div`

position: absolute;
right: 5px;
margin: 0;
padding: 0;
`

const StyledCard = Styled.div`
display: flex;
justify-content: center;
flex-direction: column;
border: 1px solid black;
width: 300px;
height: 300px;
margin: 5px;
padding: 5px;
background:#060c21;
color: white;
border-radius: 10%;
word-break:break-all;

:hover{
  opacity: 0.9;
  transform: scale(1.05);
 transition: transform 1s;
}

`
export {
  StyledFooter,
  StyledLayout,
  StyledTaps,
  StyledButton,
  StyledForm,
  StyledCard,
  TapTag,
  StyledDiv,
  Wrapper,
  SecretDiv,
  fadeAnimation,
  FadeText,
  FadeText2,
  Container,
  FooterLinksDiv,
}
